import categoriesConfig from '../config/categories.json';

export const getCategoryConfig = (categoryName) => {
  if (!categoryName || typeof categoryName !== 'string') {
    return categoriesConfig.defaultCategory;
  }
  
  const category = categoriesConfig.categories[categoryName.toUpperCase()];
  return category || categoriesConfig.defaultCategory;
};

export const getAllCategories = () => {
  return categoriesConfig.categories;
};

export const getCategoryColors = (categoryName) => {
  const config = getCategoryConfig(categoryName);
  return {
    backgroundColor: config.backgroundColor,
    textColor: config.textColor
  };
};

export const getCategoryImage = (categoryName) => {
  const config = getCategoryConfig(categoryName);
  return config.displayImage;
};

export const renderCategoryDisplay = (categoryName) => {
  const config = getCategoryConfig(categoryName);
  const colors = getCategoryColors(categoryName);
  
  return {
    name: config.name,
    style: {
      backgroundColor: colors.backgroundColor,
      color: colors.textColor
    },
    image: config.displayImage
  };
};